import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';

// Quote Carousel
const quoteCarouselElements = document.querySelectorAll( '.quote-carousel' );

quoteCarouselElements.forEach( sliderInstance => {
	new Swiper( sliderInstance, {
		modules: [ Pagination ],
		loop: true,
		slidesPerView: 1,
		spaceBetween: 15,
		threshold: 1,
		autoplay: {
			delay: 5000,
		},
		pagination: {
			el: '.swiper-pagination',
			clickable: true,
		},
	} );
} );

// Related Carousel
const relatedSliderElements = document.querySelectorAll( '.related-slider' );

relatedSliderElements.forEach( sliderInstance => {
	new Swiper( sliderInstance, {
		modules: [ Navigation ],
		loop: true,
		slidesPerView: 1,
		spaceBetween: 15,
		threshold: 1,
		navigation: {
			nextEl: '.swiper-button-next',
			prevEl: '.swiper-button-prev',
		},
		autoplay: {
			delay: 5000,
		},
		breakpoints: {
			370: {
				slidesPerView: 2,
			},
			900: {
				slidesPerView: 3,
			},
			1240: {
				slidesPerView: 4,
			},
		},
	} );
} );

// Woocommerce Block has class .is-carousel
const productBlockCarousels = document.querySelectorAll( '.is-carousel' );

productBlockCarousels.forEach( sliderInstance => {
	sliderInstance.classList.add( 'swiper' );
	sliderInstance.querySelector( '.wc-block-grid__products' ).classList.add( 'swiper-wrapper' );

	sliderInstance.insertAdjacentHTML( 'beforeend', '<div class="swiper-button swiper-button-prev"></div><div class="swiper-button swiper-button-next"></div>' );

	sliderInstance.querySelectorAll( '.wc-block-grid__product' ).forEach( slide => {
		slide.classList.add( 'swiper-slide' );
	} );

	new Swiper( sliderInstance, {
		modules: [ Navigation ],
		loop: true,
		slidesPerView: 2,
		spaceBetween: 15,
		threshold: 1,
		centeredSlides: true,
		navigation: {
			nextEl: '.swiper-button-next',
			prevEl: '.swiper-button-prev',
		},
		autoplay: {
			delay: 5000,
		},
		breakpoints: {
			370: {
				slidesPerView: sliderInstance.dataset.columns < '2' ? sliderInstance.dataset.columns : 2,
			},
			768: {
				slidesPerView: sliderInstance.dataset.columns < '3' ? sliderInstance.dataset.columns : 3,
			},
			1024: {
				slidesPerView: sliderInstance.dataset.columns < '4' ? sliderInstance.dataset.columns : 4,
			},
			1240: {
				slidesPerView: sliderInstance.dataset.columns,
			},
		},
	} );
} );

// Woocommerce Block has class .products-carousel
const productCarouselElement = document.querySelectorAll( '.products-carousel' );

productCarouselElement.forEach( sliderInstance => {
	sliderInstance.classList.add( 'swiper' );
	sliderInstance.querySelector( 'ul' ).classList.add( 'swiper-wrapper' );

	sliderInstance.insertAdjacentHTML( 'beforeend', '<div class="swiper-button swiper-button-prev"></div><div class="swiper-button swiper-button-next"></div>' );

	sliderInstance.querySelectorAll( 'li' ).forEach( slide => {
		slide.classList.add( 'swiper-slide' );
	} );

	new Swiper( sliderInstance, {
		modules: [ Navigation ],
		loop: true,
		slidesPerView: 2,
		spaceBetween: 15,
		threshold: 1,
		navigation: {
			nextEl: '.swiper-button-next',
			prevEl: '.swiper-button-prev',
		},
		autoplay: {
			delay: 5000,
		},
		breakpoints: {
			370: {
				slidesPerView: sliderInstance.dataset.columns < '2' ? sliderInstance.dataset.columns : 2,
			},
			768: {
				slidesPerView: sliderInstance.dataset.columns < '3' ? sliderInstance.dataset.columns : 3,
			},
			1024: {
				slidesPerView: sliderInstance.dataset.columns < '4' ? sliderInstance.dataset.columns : 4,
			},
			1240: {
				slidesPerView: sliderInstance.dataset.columns,
			},
		},
	} );
} );

// Addon Images
const addonImagesElements = document.querySelectorAll( '.addon-slider' );

addonImagesElements.forEach( sliderInstance => {
	new Swiper( sliderInstance, {
		modules: [ Pagination ],
		loop: true,
		slidesPerView: 2,
		centeredSlides: true,
		spaceBetween: 15,
		threshold: 1,
		pagination: {
			el: '.swiper-pagination',
			clickable: true,
		},
		autoplay: {
			delay: 3000,
		},
		breakpoints: {
			600: {
				slidesPerView: 4,
			},
		},
	} );
} );
